module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Account-Creation_04-be4480ca7f0963690c352a4b2c5eeef8.jpg";